import { useQuery } from "@tanstack/react-query";
import { apiJson } from "@/lib/api-client";

export type HistoryRange = "15m" | "1h" | "6h" | "1d" | "3d" | "7d";

export interface HistoryRow {
  captured_at: string;
  net: number | null;
  equity: number | null;
  safe_factor: number | null;
}

export function useOverviewHistory(range: HistoryRange) {
  return useQuery<HistoryRow[]>({
    queryKey: ["history", range],
    queryFn: () => apiJson<HistoryRow[]>(`/history?range=${range}`),
    refetchInterval: 30000,
  });
}
